module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/player/player-admin.component.css
// module id = ./src/app/admin/player/player-admin.component.css
// module chunks = main